<script setup lang="ts">

import LazyFooter from '~/components/Layout/Footer.vue'
import { useBannerStore } from '~/stores/useBannerStore';

const { loadBanner } = useBannerStore()
const { loadFooter } = useFooterStore()
const { isDev } = useEnvVariables()

useAsyncData('banner', async () => loadBanner())
useAsyncData('footer', async () => loadFooter())
</script>

<template>
  <div class="flex h-full w-full flex-col bg-white text-slate-600" :class="{
    ['debug-screens']: isDev,
  }">
    <slot />
    <LazyFooter />
  </div>
</template>
